import React, { useCallback, useEffect, useRef, useState } from "react";
import block from "bem-cn";
import { useSelector } from "react-redux";
import SVG from "components/SVG";

import { IMAGE_FORMAT } from "../utils/getImageFormat";
import useNotificationImageFormat from "../model/useNotificationImageFormat";

import { parseHighlightText, parseOrNot } from "../utils/parseText";
import crossSVG from '../img/cross.svg';

import './NotificationItem.scss';

const b = block('notification-item');

const getMaxLines = (isImgExist, imgFormat) => {
  if (isImgExist) {
    if (imgFormat === IMAGE_FORMAT.SQUARE) return 3;
    if (imgFormat === IMAGE_FORMAT.RECTANGLE) return 6;
  }

  return 2;
};

const NotificationItem = ({ item, setActiveItem, hideNotification }) => {
  const locale = useSelector(state => state.locale.locale);

  const textRef = useRef(null);
  const [showButton, setShowButton] = useState(false);

  const isImgExist = Boolean(item.img);
  const { imageFormat: imgFormat, handleImageLoad } = useNotificationImageFormat(item.img);

  const imgClassName = imgFormat
    ? b('bottom-right-img', { format: imgFormat })
    : b('bottom-right-img');

  const maxAllowedLines = getMaxLines(isImgExist, imgFormat);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const lineHeight = 16;
      const maxLines = maxAllowedLines;
      const maxHeight = lineHeight * maxLines;
      if (el.scrollHeight > maxHeight + 1) {
        setShowButton(true);
      }
    }
  }, [item.text, maxAllowedLines]);

  return (
    <div className={b()} data-id={item.id} data-new={item.new} >
      <div className={b('top')}>
        <div className={b('left')}>
          {item.new && <div className={b('new')}>{locale.new}</div>}
          <div className={b('type', { new: item.new })}>{locale.typesOfNotifications?.[item.tag]}</div>
        </div>
        <div className={b('right')}>
          <div className={b('date')}>{item.date}</div>
          <div className={b('cross-wrapper')} onClick={() => hideNotification(item.id)}>
            <SVG className={b('cross').toString()} svgProps={{ svg: crossSVG }} />
          </div>
        </div>
      </div>

      <div className={b('bottom')} onClick={() => isImgExist ? setActiveItem(item) : null}>
        <div className={b('bottom-left')}>
          <div className={b('bottom-text', { lines: maxAllowedLines })} ref={textRef}>
            {parseOrNot(item.tag) ? parseHighlightText(item.text) : item.text}
          </div>

          {showButton && (
            <div
              className={b('bottom-left-bottom')}
              onClick={(event) => {
                event.stopPropagation();
                setActiveItem(item);
              }}
            >
              {locale.showAll}
            </div>
          )}
        </div>

        {isImgExist && (
          <div className={b('bottom-right')}>
            <div className={imgClassName}>
              <img src={item.img} alt="" onLoad={handleImageLoad} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationItem;
